// --------------------------------------------------------------
// Created On: 2022-05-19
// Author: Zachary Thomas
//
// Last Modified: 2025-10-27
// Modified By: Zachary Thomas
//
// Copyright 2024 - 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import styles from "./Widget.module.scss";

// Stylized wrapper for content.
export default function Widget(props: Props): Component {
  return <div className={`${styles.body} shadow-sm ${props.extendClass}`}>{props.children}</div>;
}

interface Props {
  extendClass?: string;
  children?: Children;
}
